import { TextField } from '@mui/material';
import React from 'react';

const TextInput = ({
  label,
  value,
  fullWidth,
  onChange,
  type = 'text',
  multiline,
  minRows = 4,
  maxRow = 4,
  onKeyUp,
  endAdornment,
  onKeyPress,
  style,
  placeholder,
  props,
}) => {
  return (
    <TextField
      {...props}
      fullWidth={fullWidth}
      placeholder={placeholder}
      onKeyUp={onKeyUp}
      type={type}
      label={label}
      value={value}
      onChange={onChange}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRow}
      onKeyPress={onKeyPress}
      InputProps={{
        sx: {
          borderRadius: multiline ? 8 : 50,
        },
        endAdornment: endAdornment,
      }}
      sx={{
        '& .MuiInputLabel-root': {
          background: '#fff',
          px: 1,
        },
      }}
      style={{ marginBottom: 15, ...style }}
    />
  );
};

export default TextInput;
